<template>

    <section
        id="resources"
        class="blog"
    >

        <div class="blog__container">

            <span class="blog__subtitle">
                {{ getHeaderSubtitle() }}
            </span>

            <h2 class="blog__title">
                {{ 'home_blog' | staticTitle }}
            </h2>

            <p class="blog__text">
                {{ 'home_blog' | staticContent }}
            </p>

            <div class="blog__slider">

                <article
                    v-for="(item, index) in blogItems"
                    :key="item.id || index"
                    class="blog-card"
                >

                    <div class="blog-card__image">

                        <img
                            v-if="item.imagenes_id"
                            :src="item.imagenes_id | imageIdToURL"
                            :alt="item.title"
                        >

                    </div>

                    <div class="blog-card__content">

                        <span
                            v-if="getCategory(item.content_alt)"
                            class="blog-card__category"
                        >
                            {{ getCategory(item.content_alt) }}
                        </span>

                        <h3>
                            {{ item.title }}
                        </h3>

                        <div class="blog-card__summary">

                            <vue-marked>
                                {{ getSummary(item.content_alt) }}
                            </vue-marked>

                        </div>

                        <router-link
                            :to="{
                                name: 'ArticleDetail',
                                params: {
                                    id: item.id,
                                    title: item.title
                                }
                            }"
                        >

                            {{ 'articles_read_more' | staticTitle }}

                            <span>
                                →
                            </span>

                        </router-link>

                    </div>

                </article>

            </div>

            <div class="blog__dots">

                <span class="active"></span>
                <span></span>
                <span></span>

            </div>

        </div>

    </section>

</template>

<script>
export default {
    name: 'HomeBlog',

    computed: {
        blogItems() {
            const items =
                this.$options.filters.portfolioFetchBy(
                    'blogs'
                );

            return Array.isArray(items)
                ? items
                : [];
        }
    },

    methods: {
        getAlt(hash) {
            return this.$options.filters.staticContentAlt(hash) || '';
        },

        getHeaderSubtitle() {
            const parts =
                this.getAlt('home_blog').split('|');

            return parts[0] || '';
        },

        getCategory(contentAlt) {
            const value =
                String(contentAlt || '');

            const match =
                value.match(
                    /\[CATEGORY:(.*?)\]/i
                );

            return match
                ? match[1].trim()
                : '';
        },

        getSummary(contentAlt) {
            return String(
                contentAlt || ''
            )
                .replace(
                    /\[CATEGORY:(.*?)\]/i,
                    ''
                )
                .trim();
        }
    }
};
</script>

<style lang="scss" scoped>
.blog {
    background:
        var(--background);

    padding:
        70px 20px;

    overflow:
        hidden;

    &__container {
        width:
            100%;

        max-width:
            500px;

        margin:
            0 auto;

        text-align:
            center;
    }

    &__subtitle {
        display:
            block;

        margin-bottom:
            15px;

        font-family:
            'Inter',
            sans-serif;

        font-size:
            12px;

        font-weight:
            600;

        letter-spacing:
            2px;

        color:
            var(--primary);

        text-transform:
            uppercase;
    }

    &__title {
        margin-bottom:
            20px;

        font-family:
            'Cormorant Garamond',
            serif;

        font-size:
            38px;

        font-weight:
            600;

        line-height:
            1;

        color:
            var(--text);
    }

    &__text {
        max-width:
            350px;

        margin:
            0 auto
            40px;

        font-family:
            'Inter',
            sans-serif;

        font-size:
            15px;

        line-height:
            1.7;

        color:
            #555;
    }

    &__slider {
        display:
            flex;

        gap:
            20px;

        overflow-x:
            auto;

        scroll-snap-type:
            x mandatory;

        padding-bottom:
            10px;

        scrollbar-width:
            none;

        &::-webkit-scrollbar {
            display:
                none;
        }
    }

    &__dots {
        display:
            flex;

        justify-content:
            center;

        gap:
            8px;

        margin:
            30px 0;

        span {
            width:
                8px;

            height:
                8px;

            border-radius:
                50%;

            background:
                #ddd;
        }

        .active {
            background:
                var(--primary);
        }
    }
}

.blog-card {
    flex:
        0 0 85%;

    display:
        flex;

    flex-direction:
        column;

    background:
        var(--white);

    text-align:
        left;

    scroll-snap-align:
        start;

    &__image {
        width:
            100%;

        height:
            240px;

        overflow:
            hidden;

        background:
            #f1f1f1;

        img {
            display:
                block;

            width:
                100%;

            height:
                100%;

            object-fit:
                cover;

            transition:
                transform .4s ease;
        }
    }

    &:hover {

        .blog-card__image img {
            transform:
                scale(1.05);
        }
    }

    &__content {
        display:
            flex;

        flex-direction:
            column;

        flex:
            1;

        padding:
            25px 5px
            10px;
    }

    &__category {
        font-family:
            'Inter',
            sans-serif;

        font-size:
            11px;

        font-weight:
            600;

        letter-spacing:
            1.5px;

        color:
            var(--primary);

        text-transform:
            uppercase;
    }

    h3 {
        margin:
            12px 0;

        font-family:
            'Cormorant Garamond',
            serif;

        font-size:
            28px;

        font-weight:
            600;

        line-height:
            1.1;

        color:
            var(--text);
    }

    &__summary {
        flex:
            1;

        ::v-deep p {
            margin:
                0 0
                20px;

            font-family:
                'Inter',
                sans-serif;

            font-size:
                14px;

            line-height:
                1.6;

            color:
                #555;
        }

        ::v-deep p:last-child {
            margin-bottom:
                0;
        }
    }

    a {
        display:
            inline-flex;

        align-items:
            center;

        gap:
            8px;

        margin-top:
            20px;

        font-family:
            'Inter',
            sans-serif;

        font-size:
            12px;

        font-weight:
            600;

        letter-spacing:
            1px;

        color:
            var(--text);

        text-decoration:
            none;

        transition:
            color .3s ease;

        span {
            color:
                var(--primary);

            transition:
                transform .3s ease;
        }

        &:hover {
            color:
                var(--primary);

            span {
                transform:
                    translateX(5px);
            }
        }
    }
}

@media (min-width: 768px) {
    .blog {
        padding:
            100px 30px;

        &__container {
            max-width:
                1200px;
        }

        &__title {
            font-size:
                52px;
        }

        &__text {
            max-width:
                500px;
        }

        &__slider {
            display:
                grid;

            grid-template-columns:
                repeat(3, 1fr);

            gap:
                30px;

            overflow:
                visible;
        }

        &__dots {
            display:
                none;
        }
    }

    .blog-card {
        flex:
            none;

        &__image {
            height:
                260px;
        }
    }
}
</style>